module.exports = __webpack_public_path__ + "static/media/28.68858607.png";